export const InlineImageTestIdFactory = {
    getInlineImageBase: () => 'image',
    getInlineImageTestId: (testId) => [InlineImageTestIdFactory.getInlineImageBase(), testId].join('-'),
};
